import { HttpContextToken } from '@angular/common/http';

export const REDIRECIONAR_EM_401 = new HttpContextToken<boolean>(() => true);
